import { AppRouter } from "@/components";
import { AuthProvider } from "@/context";

function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
